// extracted by mini-css-extract-plugin
export default {"tile":"biUcpv","card":"ciUcpv","link":"diUcpv","details":"eiUcpv","headline":"fiUcpv","previewText":"giUcpv","article":"hiUcpv","videoIcon":"iiUcpv"};